export class ConciliacionCsvRequest {
  constructor(public readonly games: Array<string>,
              public readonly date: string) {
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/conciliacion/conciliacion-csv-request.ts